/*
 * Module for the Withholding/_OldFederalOrState view
*/

rs.module("ui/content/benefits/withholdings/withholding/oldfederalwithholding",

    [
        "common/select-helper",
        "common/visibility",
        "controls/components/event-banner"
    ],

    function (selectHelper, visibility, eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, withholdingElection, backendUrls, withholdingKey, withholdingType, defaultEffectiveDate) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);
            var calculatedForm = $.js(jsSelectors.calculatedForm);
            var electionSelect = form.js(jsSelectors.electionSelect);
            var stateSelect = form.js(jsSelectors.stateSelect, { required: false });
            var flatAmountTextBox = form.js(jsSelectors.flatAmountTextBox);
            var percentAmountTextBox = form.js(jsSelectors.percentAmountTextBox);
            var filingStatusSelect = form.js(jsSelectors.filingStatusSelect);
            var exemptionTextbox = form.js(jsSelectors.exemptionTextbox);
            var extrawithholdingTextbox = form.js(jsSelectors.extrawithholdingTextbox);
            var calculateButton = form.js(jsSelectors.calculateButton);
            var loadingSpinner = form.js(jsSelectors.loadingSpinner);

            // Get select helper
            var filingStatusSelectHelper = selectHelper.getHelper(filingStatusSelect);

            // Register events
            electionSelect.change(onElectionChanged);
            stateSelect.change(function () { eventBanner.removeAllMessages(); });
            calculateButton.click(_.debounce(getCalculations,300));

            // Event handler for when the selected election changes
            function onElectionChanged() {

                // Clear all fields
                clearFields();
                eventBanner.removeAllMessages();

                var election = electionSelect.val();

                flatAmountTextBox.setDisabled(election != withholdingElection.flatAmount);
                percentAmountTextBox.setDisabled(election != withholdingElection.percent);
                filingStatusSelectHelper.setDisabled(election != withholdingElection.taxTable && election != withholdingElection.taxTablePlusExtra);
                exemptionTextbox.setDisabled(election != withholdingElection.taxTable && election != withholdingElection.taxTablePlusExtra);
                extrawithholdingTextbox.setDisabled(election != withholdingElection.taxTablePlusExtra);
            }

            // Function to calculate the new benefit withholding
            function getCalculations() {

                // Validate form before showing spinner and hiding fields
                var validator = form.validate();
                var isValid = validator.form();

                if (!isValid) {

                    // Scroll to view the first error.
                    validator.errorList[0].element.scrollIntoView({ behavior: "smooth", block: 'center' });
                    return;
                }

                // Remove messages and show spinner
                eventBanner.removeAllMessages();
                loadingSpinner.show();
                calculateButton.setDisabled(true);

                // Make call to backend.
                $.post(
                    backendUrls.calculateNetBenefitAsync,
                    {
                        withholdingKey: withholdingKey,
                        withholdingType: withholdingType,
                        withholdingElection: electionSelect.val(),

                        filingStatus: filingStatusSelect.val(),
                        state: stateSelect.val(),
                        flatDollarAmount: flatAmountTextBox.val(),
                        percentOfTaxable: percentAmountTextBox.val(),
                        exemptions: exemptionTextbox.val(),
                        extraWithholding: extrawithholdingTextbox.val(),
                        effectiveDate: defaultEffectiveDate,

                        annualJobPay: 0,
                        otherAnnualPension: 0,
                        totalJobPensionIncome: 0,
                        childDependentCredit: 0,
                        otherDependentCredit: 0,
                        otherTaxCredit: 0,
                        totalTaxCredit: 0,
                        otherIncome: 0,
                        deductions: 0,
                    })
                    .done(function (calculatedHtml) {

                        calculatedForm.html(calculatedHtml);
                        visibility.hide(form);
                        visibility.show(calculatedForm);

                        var saveButton = calculatedForm.js(jsSelectors.saveButton);
                        var cancelButton = calculatedForm.js(jsSelectors.cancelButton);
                        var saveLoadingSpinner = calculatedForm.js(jsSelectors.saveLoadingSpinner);

                        // configure on click button
                        saveButton.on("click enterpressed", function () {
                            saveLoadingSpinner.show();
                            form.submit();
                        });

                        cancelButton.on("click enterpressed", function () {
                            visibility.hide(calculatedForm);
                            visibility.show(form);
                            calculatedForm.html(null);
                        });

                    })
                    .fail(function () {

                        // Scroll the window back to the top in the case of an error so that the error panel is in view.  
                        document.documentElement.scrollIntoView({ behavior: "smooth", block: 'center' });
                    })
                    .always(function () {

                        calculateButton.setDisabled(false);
                        loadingSpinner.hide();
                    });
            }

            // Clear fields
            function clearFields() {
                flatAmountTextBox.val('').clearErrors();
                percentAmountTextBox.val('').clearErrors();
                percentAmountTextBox.val('').clearErrors();
                exemptionTextbox.val('').clearErrors();
                extrawithholdingTextbox.val('').clearErrors();
                filingStatusSelectHelper.selectIndex(0);
                filingStatusSelect.clearErrors();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);